module.exports = __webpack_public_path__ + "img/richangtijian.7bf34606.png";